; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('CategoryManager', ['Vue'], factory);
    } else {
        // Browser globals
        root.CategoryManager = factory(Vue);
    }
}(typeof self !== 'undefined' ? self : this, function (Vue) {
    'use strict';

    if (typeof (Vue) !== 'function') {
        throw new ReferenceError('CategoryManager depends on Vue')
    }

    function ucFirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function readFromDOM(name) {
        var attr = this.container.dataset[name];
        if (this.container.querySelector('var[name="' + name + '"]')) {
            attr = this.container.querySelector('var[name="' + name + '"]').getAttribute('value');
        }
        return attr;
    }

    function fromMeta(propertyName) {
        var prop = document.querySelector('meta[property="' + propertyName + '"]');
        if (!prop) return null;
        return prop.getAttribute('content');
    }

    function loadFormData(container) {
        var formData = new FormData();
        var inputs = container.querySelectorAll('input');

        Array.prototype.forEach.apply(inputs, [function (el) {
            var name = el.getAttribute('name');
            if (!name) return;
            var value = el.getAttribute('value');
            formData.set(name, value);
        }]);

        return formData;
    }

    function readOptions(thisarg, defaults, prefix) {

        var data = {}

        Object.keys(defaults).forEach(function (key) {
            key = typeof (prefix) === 'string' ? prefix + ucFirst(key) : key;

            // Default option is function: do not read from DOM variable
            if (typeof (defaults[key]) === 'function' || defaults[key] === null) {
                data[key] = defaults[key];
                return;
            }

            if (typeof (defaults[key]) === 'object') {
                if (Array.isArray(defaults[key])) {
                    data[key] = defaults[key]
                } else {

                }
            }

            var value = readFromDOM.apply(thisarg, [key]);

            if (typeof (value) === 'undefined') {
                return;
            }

            // Default option is string: read from DOM variable as-is
            if (typeof (defaults[key] === 'string')) {
                data[key] = readFromDOM.apply(thisarg, [key]);
                return;
            }

            // Default option is number: read from DOM only if DOM variable is number
            if (typeof (defaults[key] === 'number')) {
                data[key] = isNaN(parseFloat(value)) ? defaultValue : parseFloat(value);
                return;
            }

        }, thisarg);

        return data;
    }

    function sortByFullName(a, b) {
        if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) {
            return -1;
        }

        if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) {
            return 1;
        }

        return 0;
    }

    function sortCategories(data) {
        var categories = data[0].map(function (cat) {
            var fav = data[1].find(function (el) { return el.CategoryID === cat.CategoryID });
            cat.Favourite = fav ? true : false;
            return {
                id: cat.CategoryID,
                name: cat.Name,
                parentName: cat.ParentName,
                fullName: cat.ParentName ? cat.ParentName + ' ' + cat.Name : cat.Name,
                favourite: fav ? true : false
            };
        });

        categories.sort(sortByFullName);

        return Promise.resolve(categories);
    }

    var DEFAULTS = {
        search: {
            value: '',
            min: 3,
            param: 'fullName',
            placeholder: 'Search...',
            hint: {
                start: 'Start typing',
                more: 'Type at least %d letters'
            },
            found: {
                many: '%d items found',
                one: 'One item found',
                none: 'No items found'
            }
        },
        text: {
            filter: {
                selected: 'Show selected',
                all: 'Show all',
            },
            recap: '%s of %a items selected',
            error: 'An error occurred'
        }
    }

    function CategoryManager(element, config) {
        this.container = element;
        if (!this.container) return;

        this.formData = loadFormData(this.container);

        this.endpoints.all = fromMeta('api:category-manager:all');
        this.endpoints.selected = fromMeta('api:category-manager:selected');
        this.endpoints.add = fromMeta('api:category-manager:add');
        this.endpoints.remove = fromMeta('api:category-manager:remove');

        this.fromTag = this.fromTag.bind(this);
        this.load = this.load.bind(this);
        this.toggleon = this.toggleon.bind(this);
        this.toggleoff = this.toggleoff.bind(this);
        this.optionsFromDOM = this.optionsFromDOM.bind(this);

        config = config || {};

        this.defaults = DEFAULTS;

        this.defaults = Object.assign({}, DEFAULTS, this.optionsFromDOM(), config, {
            param: this.fromTag('param', 'name'),
            property: this.fromTag('property', 'selected'),
            toggleon: this.toggleon,
            toggleoff: this.toggleoff,
            source: Promise.all([
                this.load(this.endpoints.all, { credentials: 'include' }),
                this.load(this.endpoints.selected, { credentials: 'include' })
            ]).then(sortCategories)
        });

        this.defaults.search = {
            value: '',
            min: this.fromTag('searchMin', 3),
            param: this.fromTag('param', 'name'),
            placeholder: this.fromTag('searchPlaceholder', 'Search...'),
            hint: {
                start: this.fromTag('searchHintStart', 'Start typing'),
                more: this.fromTag('searchHintMore', 'Type at least %d letters')
            },
            found: {
                many: this.fromTag('searchFoundMany', '%d items found'),
                one: this.fromTag('searchFoundOne', 'One item found'),
                none: this.fromTag('searchFoundNone', 'No items found')
            }
        }

        this.defaults.text = {
            filter: {
                all: this.fromTag('textFilterAll', 'Show all'),
                selected: this.fromTag('textFilterSelected', 'Show selected')
            },
            recap: this.fromTag('textRecap', '%s of %a items selected'),
            error: this.fromTag('textError', 'An error occurred')
        }

        this.instance = new Vue({
            name: 'category-manager',
            el: element,
            template: '<toggle-manager :text="text" :search="search" :prefilter="true" :source="source" :param="param" :property="property" :toggleon="toggleon" :toggleoff="toggleoff"></toggle-manager>',
            data: this.defaults
        })
    }

    CategoryManager.prototype = {
        endpoints: {
            all: null,
            auction: null,
            add: null,
            remove: null
        },
        optionsFromDOM: function () {
            return readOptions(this, this.defaults, null);
        },
        fromTag: function (name, value) {
            var attr = this.container.dataset[name];
            if (this.container.querySelector('var[name="' + name + '"]')) {
                attr = this.container.querySelector('var[name="' + name + '"]').getAttribute('value');
            }

            if (typeof (value) === 'number') {
                attr = parseInt(attr);
                return isNaN(attr) ? value : attr;
            }

            return attr ? attr : value
        },
        load: function (url, request) {
            if (typeof (url) !== 'string') return Promise.reject(new ReferenceError('No url to fetch'));
            return fetch(url, request)
                .then(function (response) { return (response.ok) ? response.json() : Promise.reject(response); })
                .catch(function (error) { return Promise.reject(error) });
        },
        toggleoff: function (item) {
            var formData = this.formData;
            formData.set('categoryID', item.id)

            return this.load(this.endpoints.remove, {
                method: 'DELETE',
                credentials: 'include',
                body: formData
            }).then(function (data) {
                item.favourite = data;
                return Promise.resolve(item);
            })
        },
        toggleon: function (item) {
            var formData = this.formData;
            formData.set('categoryID', item.id);

            return this.load(this.endpoints.add, {
                method: 'POST',
                credentials: 'include',
                body: formData
            }).then(function (data) {
                item.favourite = data;
                return Promise.resolve(item);
            });
        }
    };

    return CategoryManager;

}));